import * as $ from 'jquery';
import * as Backbone from 'backbone';
import * as Radio from 'backbone.radio';
import * as Marionette from 'backbone.marionette';
import { on, Options } from "../utils/decorators";



interface props {
  controller: any
}

class Option {
  name: string;  
  score: number;

  constructor(name: string, score: number) {
    this.name = name;    
    this.score = score;
  }
}

class CheckableOption extends Option {
  isSelected: boolean;

  constructor(name: string, score: number) {
    super(name, score);
    this.isSelected = false;
  }
}

@Options({
  el: 'body',
  template: false,
  ui: {
    inputItem: '#choicelist input',
    selectedItem: '#selectedDigitalNeeds',
    choiceList: '#choicelist',
    pageMain: 'main',
    optionTag: '#tagList .option-tag',
    numberOfDevices: '#numberOfDevices',
    goButton: '#goBtn',
    clearButton: '#clearBtn'
  }
})

export default class ViewController extends Marionette.View<Backbone.Model>{

  options: Array<Option> = [];
  checkableOptions: Array<CheckableOption> = [];

  _this = this;

  isMenuOpen: boolean = false;
  devicesScore: number = 0;
  digitalScore: number = 0;
  totalScore: number = 0;

  midTierThreshold = 20;
  highTierThreshold = 40;

  priceCardSelectors = document.querySelectorAll(".js-fiber-plan-estimator + .card-columns-module .col-md-4");

  addOption(optionName, optionScore) {
    const opt = new Option(optionName, optionScore);
    this.options.push(opt);
  }

  addCheckableOption(optionName, optionScore) {
    const opt = new CheckableOption(optionName, optionScore);
    this.checkableOptions.push(opt);
  }

  setMidTierThreshold(score: number) {
    this.midTierThreshold = score;
  }

  setHighTierThreshold(score: number) {
    this.highTierThreshold = score;
  }

  generateDevicesDropdown() {
    const deviceDropdown = document.querySelector(".js-fiber-plan-estimator #numberOfDevices");

    deviceDropdown.innerHTML = "";

    const defaultOption: HTMLOptionElement = document.createElement("option");

    defaultOption.value = "none";
    defaultOption.selected = true;
    defaultOption.disabled = true;
    defaultOption.hidden = true;
    defaultOption.innerHTML = "Select";

    deviceDropdown.appendChild(defaultOption);

    this.options.forEach(el => {
      const opt = document.createElement("option");

      opt.value = el.name;
      opt.innerHTML = el.name;

      deviceDropdown.appendChild(opt);
    });
  }

  generateDigitalDropdown() {
    const choiceList = document.querySelector('#choicelist');
    choiceList.innerHTML = '';

    this.checkableOptions.forEach(el => {
      const outerDiv = document.createElement("div");

      const name = el.name;
      const id = name.replace(/\s+/g, '-');
      const isSelected = el.isSelected;

      const inputEl = document.createElement('input');
      inputEl.type = "checkbox";
      inputEl.name = name;
      inputEl.id = id;
      if (isSelected === true) {
        inputEl.checked = true;
      }

      const labelEl = document.createElement('label');
      labelEl.htmlFor = id;
      labelEl.innerHTML = name;

      outerDiv.appendChild(inputEl);
      outerDiv.appendChild(labelEl);
      
      choiceList.appendChild(outerDiv);
    });    

  }

  updateCheckBoxes() {
    this.checkableOptions.forEach(el => {
      const id = el.name.replace(/\s+/g, '-');
      const selector: HTMLInputElement = document.querySelector(`input#${id}`);
      if (el.isSelected === true) {
        selector.checked = true;
      } else {
        selector.checked = false;
      }
    });
  }
  

  toggleChecked(itemName: string) {
    const objIndex = this.checkableOptions.findIndex(obj => obj.name === itemName);
    if(this.checkableOptions[objIndex].isSelected === true) {
      this.checkableOptions[objIndex].isSelected = false;
    } else {
      this.checkableOptions[objIndex].isSelected = true;
    }
  }

  updateDeviceScore(itemName: string) {
    const _this = this;    

    const objIndex = _this.options.findIndex(obj => obj.name === itemName);

    _this.devicesScore = _this.options[objIndex].score;
  }

  updateDigitalScore() {
    let total = 0;

    this.checkableOptions.forEach(el => {
      if (el.isSelected === true) {
        total += el.score;
      }
    });

    this.digitalScore = total;
  }

  updateFinalScore() {
    this.updateDigitalScore();

    this.totalScore = this.devicesScore + this.digitalScore;
  }

  resetCheckableOptions() {
    this.checkableOptions.forEach(el => {
      el.isSelected = false;
    });
  }
  

  toggleMenu() {    
    if (this.isMenuOpen === true) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  
  resetCards() {
    this.priceCardSelectors.forEach( el => {
      el.classList.remove("selected-col");
    });
  }

  selectCard(index: number) {
    this.resetCards();
    console.log(this.priceCardSelectors);
    this.priceCardSelectors[index].classList.add("selected-col");
  }

  calculateCardToSelect() {
    if (this.totalScore >= this.highTierThreshold) {
      this.selectCard(2);
    } else if (this.totalScore >= this.midTierThreshold) {
      this.selectCard(1);
    } else {
      this.selectCard(0);
    }
  }


  generateTags() {
    const tagList = document.querySelector('.js-fiber-plan-estimator #tagList');
    tagList.innerHTML = '';

    this.checkableOptions.forEach(el => {
      if (el.isSelected === true) {
        const tag = document.createElement('span');
        tag.classList.add('option-tag');
        tag.innerHTML = el.name;
        tagList.appendChild(tag);
      }      
    });
    
  }


  openMenu() {
    this.isMenuOpen = true;
    this.generateDigitalDropdown();
    $(this.ui.selectedItem).attr("aria-expanded", "true");
    $("#choicelist").css("display", "block");
    $("#selectedDigitalNeeds .fa-chevron-down").addClass("fa-chevron-down--open");  
  }

  closeMenu() {
    this.isMenuOpen = false;
    $(this.ui.selectedItem).attr("aria-expanded", "false");
    $("#choicelist").css("display", "none");
    $("#selectedDigitalNeeds .fa-chevron-down").removeClass("fa-chevron-down--open");
  }

  calculateItemsSelected() {
    const itemCount = $("#choicelist input:checked").length;
    if (itemCount == 0)
      $("#DBXPList").html("Select");
    else if (itemCount == 1)
      $("#DBXPList").html($("label[for='" + $("#choicelist input:checked")[0].id + "']").text());
    else
      $("#DBXPList").html(itemCount + " items selected");      
  }

  @on("change @ui.inputItem")
  OnItemChange(ev) {    
    this.toggleChecked(ev.target.name);    
    this.updateCheckBoxes();
    this.generateTags();
    this.calculateItemsSelected();
  }
  
  @on("keyup @ui.inputItem")
  OnItemKeyUp(ev) {
  if (ev.keyCode == 27)
    {
      this.toggleMenu();
      $("#selectedDigitalNeeds").focus();
    }    
  }

  @on("keyup @ui.selectedItem")
  OnSelectedItemKeyUp(ev) {    
    if (ev.keyCode == 13) {
      this.toggleMenu();
      $('#choicelist').focus();
    }
  }

  @on("click @ui.optionTag")
  OnClickOptionTag(ev) {
    this.toggleChecked(ev.target.innerHTML);
    this.generateTags();
    this.generateDigitalDropdown();
    this.calculateItemsSelected();
  }

  @on("change @ui.numberOfDevices")
  OnChangeNumberOfDevices(ev) {    
    this.updateDeviceScore(ev.target.value);
  }


  //listen on <main> for event to see if the dropdown was clicked inside or outside
  @on("click @ui.pageMain")
  CancelMenu(ev) {
    const target = $(ev.target);    
    if (ev.target.id === 'selectedDigitalNeeds' || target.closest('#selectedDigitalNeeds').length) {
      this.toggleMenu();
    } else if (target.closest('#choicelist').length) {
      // do nothing if the dropdown is clicked inside so it stays open
    } else {
      this.closeMenu();
    }
  }

  @on("click @ui.goButton")
  OnClickGo() {
    this.updateFinalScore();
    this.calculateCardToSelect();
    const selectedCard = document.querySelector('.selected-col');
    selectedCard.scrollIntoView({ behavior: 'smooth', block: 'center'});
  }

  @on("click @ui.clearButton")
  ClearEverything(ev) {
    this.generateDevicesDropdown();
    this.resetCheckableOptions();
    this.generateDigitalDropdown();
    this.generateTags();
    this.calculateItemsSelected();
    this.resetCards();
  }


  onRender() {
    if(document.querySelector('.js-fiber-plan-estimator')) {
      let _this = this;

      _this.addOption('Less than 5 employees', 0);
      _this.addOption('5-25 employees', 10);
      _this.addOption('25 or more employees', 20);
      
      _this.addCheckableOption('Email', 2);
      _this.addCheckableOption('File sharing', 2);
      _this.addCheckableOption('HD Video', 2);
      _this.addCheckableOption('Cloud backups', 2);
      _this.addCheckableOption('Live Streaming', 4);
      _this.addCheckableOption('HD Digital Streaming', 3);
      _this.addCheckableOption('Multi-device file upload', 3);

      _this.setMidTierThreshold(10);
      _this.setHighTierThreshold(20);

      _this.generateDevicesDropdown();
    }
  }
}



// WEBPACK FOOTER //
// ./Websites/FrontierEnterprise.Web/@static/@modules/fiber-plan-estimator/controller.ts